var map = {
	"./angular.svg": "./src/assets/images/icons/angular.svg",
	"./apple-safari.png": "./src/assets/images/icons/apple-safari.png",
	"./book.svg": "./src/assets/images/icons/book.svg",
	"./bootstrap.svg": "./src/assets/images/icons/bootstrap.svg",
	"./brush.svg": "./src/assets/images/icons/brush.svg",
	"./caret-down-fill.svg": "./src/assets/images/icons/caret-down-fill.svg",
	"./caret-up-fill.svg": "./src/assets/images/icons/caret-up-fill.svg",
	"./doc.png": "./src/assets/images/icons/doc.png",
	"./drive.png": "./src/assets/images/icons/drive.png",
	"./dropbox.png": "./src/assets/images/icons/dropbox.png",
	"./figma.svg": "./src/assets/images/icons/figma.svg",
	"./google-chrome.png": "./src/assets/images/icons/google-chrome.png",
	"./icloud-1.png": "./src/assets/images/icons/icloud-1.png",
	"./icloud.png": "./src/assets/images/icons/icloud.png",
	"./internet-explorer.png": "./src/assets/images/icons/internet-explorer.png",
	"./internet.png": "./src/assets/images/icons/internet.png",
	"./jpg.png": "./src/assets/images/icons/jpg.png",
	"./js.png": "./src/assets/images/icons/js.png",
	"./json.png": "./src/assets/images/icons/json.png",
	"./mozila-firefox.png": "./src/assets/images/icons/mozila-firefox.png",
	"./onedrive.png": "./src/assets/images/icons/onedrive.png",
	"./onedrivenew.png": "./src/assets/images/icons/onedrivenew.png",
	"./opera.png": "./src/assets/images/icons/opera.png",
	"./parachute.svg": "./src/assets/images/icons/parachute.svg",
	"./pdf.png": "./src/assets/images/icons/pdf.png",
	"./psd.png": "./src/assets/images/icons/psd.png",
	"./react.svg": "./src/assets/images/icons/react.svg",
	"./rocket.svg": "./src/assets/images/icons/rocket.svg",
	"./sketch.png": "./src/assets/images/icons/sketch.png",
	"./speaker.svg": "./src/assets/images/icons/speaker.svg",
	"./star.svg": "./src/assets/images/icons/star.svg",
	"./toolbox.svg": "./src/assets/images/icons/toolbox.svg",
	"./txt.png": "./src/assets/images/icons/txt.png",
	"./unknown.png": "./src/assets/images/icons/unknown.png",
	"./voucher_ticket.png": "./src/assets/images/icons/voucher_ticket.png",
	"./vuejs.svg": "./src/assets/images/icons/vuejs.svg",
	"./xls.png": "./src/assets/images/icons/xls.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/icons sync \\.(png|jpe?g|svg)$";